import React from "react";
import Select from "components/forms/Select";
import { Card, CardBody, Row, Col } from "reactstrap";
import { LISTA_REGIONES } from "../../data/ubigeo.data";
import "./seccion-cabecera-filtro.scss";
import Ubigeo from "../../commons/ubigeo.module";
import {
  getObjectTematica,
  LISTA_TEMATICAS,
} from "../../data/marco-ordenador.data";
let NEW_LISTA_TEMATICAS = [];

class SeccionCabecera extends React.Component {
  render() {
    let regionSelecionada = Ubigeo.getObjectRegion(this.props.ubigeo);
    let marcoSeleccionada = getObjectTematica(this.props.marco);
    NEW_LISTA_TEMATICAS = LISTA_TEMATICAS;
    if (this.props.default) {
      if (LISTA_TEMATICAS.length > 0) {
        NEW_LISTA_TEMATICAS = [{ value: "", label: "Todos" }];
        if (!marcoSeleccionada) {
          marcoSeleccionada = { value: "", label: "Todos" };
        }
        LISTA_TEMATICAS.forEach(function(item) {
          NEW_LISTA_TEMATICAS.push(item);
        });
      }
    }
    return (
      <Row>
        <Col>
          <Card className="card-border-line">
          <CardBody className="card-body-header">
          <Row>
              <Col xs={12} sm={12} md={4} xl={4} style={{zIndex:600}}>
                <Select
                  store={LISTA_REGIONES}
                  item_default={regionSelecionada}
                  scope={this}
                  onChange={this.onUbigeoChange}
                  placeholder="Seleccione una región"
                />
              </Col>
              <Col xs={12} sm={12} md={4} xl={4} style={{zIndex:550}}>
                <div className="d-none d-md-block d-lg-block ml-3">
                  <Select
                    store={NEW_LISTA_TEMATICAS}
                    item_default={marcoSeleccionada}
                    scope={this}
                    onChange={this.onMarcoChange}
                    placeholder="Seleccione una Temática"
                  />
                </div>
                <div  className="d-block d-md-none d-lg-none mt-2">
                  <Select
                    store={NEW_LISTA_TEMATICAS}
                    item_default={marcoSeleccionada}
                    scope={this}
                    onChange={this.onMarcoChange}
                    placeholder="Seleccione una Temática"
                  />
                </div>
              </Col>
            </Row>
          </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
  onUbigeoChange(itemsSeleccionados) {
    let props = this.props;
    let scope = this.props.scope || this;
    if (props.onChangeUbigeo) {
      props.onChangeUbigeo.call(scope, itemsSeleccionados[0].value);
    }
  }
  onMarcoChange(itemsSeleccionados) {
    let props = this.props;
    let scope = this.props.scope || this;
    if (props.onChangeMarco) {
      props.onChangeMarco.call(scope, itemsSeleccionados[0].value);
    }
  }
}
export default SeccionCabecera;
